module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kbfg_m.652743fa7cdca416bb3f925bb949a4c8.png";